import { DIRECTION_VERT, DIRECTION_HORZ } from '../const'

export default direction => {
    switch (direction) {
        case DIRECTION_VERT:
            return ['top', 'bottom']
        case DIRECTION_HORZ:
            return ['left', 'right']
        default:
            return []
    }
}
